export default "__VITE_ASSET__CRu1YEyq__"